
<script setup lang="ts">
import { onBeforeMount, provide } from 'vue';
import { useRoute } from 'vue-router'
import { verifyActivitySession, redirectToNotFound, setLocation, getCompanySlug } from 'host/mfeBridge';
import { getHostRouter } from '@Src/mfe.config';
import { useLocationStore } from '@Stores/location.store';
import { useEsignatureFlowStore } from '@Stores/esignatureFlow.store';
import { getDashboardContextApi } from '@Api/navigation.api';

provide('backToDashboard:hostRouter', getHostRouter());
provide('backToDashboard:slug', () => getCompanySlug());
provide('backToDashboard:flowStore', useEsignatureFlowStore());
provide('backToDashboard:getDashboardContext', getDashboardContextApi);

import { addRequestDetailsToActivitySessionByRecipientTokenApi } from '@Api/activitySession.api';
import { checkInviteRedirectApi } from '@Api/inviteRedirect.api';

const route = useRoute();

onBeforeMount(async () => {

    const token = route.params.token as string || '';
    const locationStore = useLocationStore();

    await verifyActivitySession();

    // Check if this esign request should redirect to the dashboard invite flow.
    // Skip when the user navigated here from the dashboard MFE (source=dashboard)
    // to avoid a redirect loop back to the dashboard they just came from.
    const fromDashboard = route.query.source === 'dashboard';
    if (token && !fromDashboard) {
        try {
            const redirectResult = await checkInviteRedirectApi(token);
            if (redirectResult?.shouldRedirect && redirectResult.redirectUrl?.startsWith('/')) {
                const slug = getCompanySlug();
                const slugSegment = slug ? `/${slug}` : '';
                window.location.href = `${slugSegment}${redirectResult.redirectUrl}`;
                return;
            }
        } catch {
            // Redirect check failed — proceed with normal esign flow
        }
    }

    try {
        console.log('[Esignature MFE] Adding request details to activity session by recipient token:', token);
        await addRequestDetailsToActivitySessionByRecipientTokenApi(token);
        await locationStore.loadLocation();
        setLocation(locationStore.location);
    } catch (error) {
        redirectToNotFound();
    }
    console.log('[Esignature MFE] mounted')
});


</script>
<template>
    <div class="mfe-container">
        <router-view  />
    </div>
</template>



<style lang="scss">

.mfe-container {
    height: 100%;

    & > * {
        height: 100%;
    }
}

</style>

